import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const BackArrow = (props: SvgProps) => <Svg
  width={24}
  height={25}
  viewBox='0 0 24 25'
  fill='none'
  {...props}
>
  <Path
    d='M14 17.5L9 12.5L14 7.5'
    stroke='#121B23'
    strokeWidth='3'
    strokeMiterlimit='10'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
</Svg>;

export default BackArrow;
